// export const stripePK = "pk_test_51HjqU9Deyn3BkxNp2J0PhmvN4Z7nBdqeWTFSvHQyxHWlXjx1pe2SCfNBCFDt5GSZfLrXoFD3A96Vh4se6GPwIxM90039exC6Q0"
export const stripePK = 'pk_live_jXgfWpLuA08COZ3TqBiH6fi4';
export const pusherPK = '3f476c83004a96f8a906';
// export const pusherPK = "8f27d8cc493d5c8b636a"
